import React from 'react';
import PropTypes from 'prop-types';
import Container from '@components/layout/container/container';
import Link from 'next/link';
import { ArrowLeft } from '@components/icons/arrow/arrow';
import StyledEducationCollectionBar from './educationCollectionBar.style';

function EducationCollectionBar({ children, link }) {
  return (
    <StyledEducationCollectionBar>
      <Container large>
        <div className="collection-bar">
          <div>
            <Link href={link} className="collection-bar__link">
              <ArrowLeft />
              <span>Zur Übersicht</span>
            </Link>
          </div>
          {children}
        </div>
      </Container>
    </StyledEducationCollectionBar>
  );
}

export default EducationCollectionBar;

EducationCollectionBar.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string.isRequired
};
